<script>
  export let loading = true;
</script>

{#if loading}
  <div class="progress-horizontal">
    <div class="bar-horizontal" />
  </div>
{/if}

<style type="text/scss" lang="scss" scoped>
  .progress-horizontal {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 2px;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .bar-horizontal {
    width: 50%;
    height: 100%;
    margin-left: 0;
    background-color: #363d46;

    animation-name: spinner;
    animation-duration: 750ms;
    animation-timing-function: ease-in-out;
    animation-play-state: running;
    animation-direction: alternate-reverse;
    animation-iteration-count: infinite;
  }

  @keyframes spinner {
    0% {
      width: 0;
    }
    50% {
      width: 100%;
      margin-left: 50%;
    }
    100% {
      width: 0;
      margin-left: 100%;
    }
  }
</style>
